import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=b1c91764&scoped=true&"
import script from "./Specialty.vue?vue&type=script&lang=js&"
export * from "./Specialty.vue?vue&type=script&lang=js&"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=b1c91764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c91764",
  null
  
)

export default component.exports